/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import Header from "./header";
import PreviewSection from "./timedAuction/PreviewSection";
import SetupSection from "./timedAuction/SetUpLot";
import { dataService } from "../../../services/dataService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LiveLotPreview from "./liveAuction/LiveLotPreview";
import LiveLotSetup from "./liveAuction/LiveLotSetup";
import { Triangle } from "react-loader-spinner";
import { Storage } from "aws-amplify";
import uuid from 'react-uuid';
import { convertToWebP } from "../../../CommonComponent/convertToWebp";
import ExitModal from "./ExitModal";

export default function CreateLot({edit}){

    const [priceError,setPriceError]=useState(false);
    const [loading,setLoading]=useState(false);
    const Navigate=useNavigate();
    const { id,lotNumber ,uid}=useParams();
    const email = localStorage.getItem('user')
    const location=useLocation();
    const auctionData = location.state?.auction;
    const total_lots = location.state?.total_lots;
    const [isBanner, setIsBanner] = useState(true);
    const [loadLots, setLoadLots] = useState(edit ? true : false);
    const [successToastMessage, setSuccessToastMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [openExitModal, setOpenExitModal] = useState(false);
    
    // Local image storage for preview
    const [localImages, setLocalImages] = useState([]);
    
    // Track old S3 images that need to be deleted when replaced
    const [oldS3Images, setOldS3Images] = useState([]);
    const [lotData, setLotData] = useState(
        {
            auction_id: uid,
            seller_email : localStorage.getItem('user'),
            title1: "",
            title2: "",
            description: "",
            ...(auctionData?.auction_type==="live" ? { reserve: "" } : { starting_price: "" }),
            low_estimate: "",
            high_estimate: "",
            shipping_details: "",
            current_bid: 0,
            tags: [],
            images: [],
        }
    )
    const [originalLotData, setOriginalLotData] = useState(null);
    const [text,setText] = useState('');

    const getLotDetails = async() =>{
        const response = await dataService.ViewLot(auctionData.auction_id, lotNumber);
        const lot = response.data.data;
        const lotDataObj = {
            auction_id: lot.auction_id || '',
            seller_email : lot.seller_email || '',
            title1: lot.title1 || '',
            title2: lot.title2 || '',
            description: lot.description || '',
            ...(auctionData?.auction_type==="live" ? 
                { reserve: lot.reserve || '' } : 
                { starting_price: lot.starting_price || '' }),
            low_estimate: lot.high_estimate!==0 ? lot.low_estimate : '',
            high_estimate: lot.high_estimate || '',
            shipping_details: lot.shipping_details || '',
            current_bid: lot.current_bid,
            tags: lot.tags || [],
            images: lot.images || [],
        }
        setLotData(lotDataObj);
        setOriginalLotData(JSON.parse(JSON.stringify(lotDataObj)));
        setText(lot.description);
        setLoadLots(false);
    }

    useEffect(()=>{
        window.scrollTo(0, 0);
        if(edit && location.state?.message){
            setSuccessToastMessage(true);
            Navigate(location.pathname, { replace: true, 
                state: {auction : location.state.auction, total_lots : location.state.total_lots } });
            setTimeout(() => {
                setSuccessToastMessage(false);
            }, 4000);
        }
        if(edit){
            setLoadLots(true);
            getLotDetails();
        }
        if(!auctionData){
            Navigate(`/auctions/${id}/${uid}/lots`)
        }
    },[])
    

    /**
     * Helper function to upload local images to S3
     */
    const uploadImagesToS3 = async (imageData) => {
        if (!imageData?.file) return null;
        
        try {
            const webpImage = await convertToWebP(imageData.file);
            const upload = await Storage.put(`DomainName/Auctions/lots/images/${uuid()}/${webpImage.name.replaceAll(' ','')}`, webpImage, {
                contentType: webpImage.type,
            });
            return upload.key;
        } catch (error) {
            console.error('Error uploading image to S3:', error);
            return null;
        }
    };

    /**
     * Helper function to delete old S3 images
     */
    const deleteOldS3Images = async () => {
        try {
            if (!oldS3Images || oldS3Images.length === 0) return;
    
            const deletePromises = oldS3Images.map((imageKey) => {
                const body = { key: imageKey };
                return dataService.deleteImageFromS3(body);
            });
    
            await Promise.all(deletePromises);
    
        } catch (error) {
            console.error("Error deleting old S3 images:", error);
        }
    };

    /**
     * The function `createLothandler` is an asynchronous function that creates a new lot by uploading
     * images to S3 first, then sending a request to the server with the provided lot data.
     */
    const createLothandler=async()=>{
        setLoading(true);
        
        try {
            // Upload all local images to S3 first
            const uploadPromises = localImages.map(imageData => uploadImagesToS3(imageData));
            const uploadedImageKeys = await Promise.all(uploadPromises);
            
            // Filter out any failed uploads
            const validImageKeys = uploadedImageKeys.filter(key => key !== null);
            
            // Prepare final images array with S3 keys
            const finalImages = lotData.images.map((image) => {
                // If it's a local image (blob URL), find the corresponding S3 key
                if (image.url && image.url.startsWith('blob:')) {
                    // Find the local image data that matches this blob URL
                    const matchingLocalImage = localImages.find(localImg => 
                        localImg.localUrl === image.url
                    );
                    
                    if (matchingLocalImage) {
                        // Find the corresponding S3 key for this local image
                        const localImageIndex = localImages.findIndex(localImg => 
                            localImg.localUrl === image.url
                        );
                        
                        if (localImageIndex !== -1 && validImageKeys[localImageIndex]) {
                            return {
                                ...image,
                                url: validImageKeys[localImageIndex]
                            };
                        }
                    }
                }
                // If it's already an S3 URL, keep it as is
                return image;
            });
            
            const body={
                auction_id: auctionData.auction_id,
                seller_email : email,
                title1: lotData.title1,
                title2: lotData.title2,
                description: lotData.description,
                ...(auctionData.auction_type==="live" ?
                    {reserve: lotData.reserve=="" ? 0 : parseInt(lotData.reserve)} : 
                    {starting_price: lotData.starting_price=="" ? 0 : parseInt(lotData.starting_price)} ),
                low_estimate: lotData.low_estimate=="" ? 0 : parseInt(lotData.low_estimate),
                high_estimate: lotData.high_estimate=="" ? 0 : parseInt(lotData.high_estimate),
                shipping_details: lotData.shipping_details,
                current_bid: 0,
                tags: lotData.tags,
                images: finalImages,
            }
            const response = await dataService.CreateLot(body, auctionData.auction_type=="live");
            setLoading(false);
            if(response.error===false){
                setSuccessToastMessage(true);
                setTimeout(() => {
                    Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/${response?.data?.lot_number}`,
                        {state : {auction : auctionData, total_lots : response?.data?.lot_number, message: true } })
                }, 100);
            }
        } catch (error) {
            console.error('Error in createLothandler:', error);
            setErrorMessage('Something went wrong, please try again');
            setLoading(false);
            setTimeout(() => {
                setErrorMessage('');
            }, 4000);
        }
    }

    /**
     * The `editLotHandler` function is an asynchronous function that handles the editing of a lot by
     * uploading images to S3 first, then sending a request to update the lot data.
     */
    const editLotHandler=async()=>{
        setLoading(true);
        
        try {
            // Upload all local images to S3 first
            const uploadPromises = localImages.map(imageData => uploadImagesToS3(imageData));
            const uploadedImageKeys = await Promise.all(uploadPromises);
            
            // Filter out any failed uploads
            const validImageKeys = uploadedImageKeys.filter(key => key !== null);
            
            // Delete old S3 images after successful upload
            await deleteOldS3Images();
            
            // Prepare final images array with S3 keys
            const finalImages = lotData.images.map((image) => {
                // If it's a local image (blob URL), find the corresponding S3 key
                if (image.url && image.url.startsWith('blob:')) {
                    // Find the local image data that matches this blob URL
                    const matchingLocalImage = localImages.find(localImg => 
                        localImg.localUrl === image.url
                    );
                    if (matchingLocalImage) {
                        // Find the corresponding S3 key for this local image
                        const localImageIndex = localImages.findIndex(localImg => 
                            localImg.localUrl === image.url
                        );
                        if (localImageIndex !== -1 && validImageKeys[localImageIndex]) {
                            return {
                                ...image,
                                url: validImageKeys[localImageIndex]
                            };
                        }
                    }
                }
                // If it's already an S3 URL, keep it as is
                return image;
            });
          
            const body={
                auction_id: uid,
                seller_email :localStorage.getItem('user'),
                title1: lotData.title1,
                title2: lotData.title2,
                description: lotData.description,
                ...(auctionData.auction_type==="live" ?
                    {reserve: lotData.reserve=="" ? 0 : parseInt(lotData.reserve)} : 
                    {starting_price: lotData.starting_price=="" ? 0 : parseInt(lotData.starting_price)} ),
                low_estimate: lotData.low_estimate=="" ? 0 : parseInt(lotData.low_estimate),
                high_estimate: lotData.high_estimate=="" ? 0 : parseInt(lotData.high_estimate),
                shipping_details: lotData.shipping_details,
                tags: lotData.tags,
                images: finalImages,
                lot_number: parseInt(lotNumber),
            }
            const response = await dataService.updateLot(body, auctionData.auction_type=="live");
            setLoading(false);
            if(response.error===false){
                setSuccessToastMessage(true);
                getLotDetails();
                setTimeout(() => {
                    setSuccessToastMessage(false);
                }, 4000);
            }else if(response.message?.response?.data.message=="Lot has already been bid"){
                setErrorMessage("This lot has already got a bid on it – you can't change the starting price.");
                setTimeout(() => {
                    setErrorMessage('');
                }, 4000);
            }else{
                setErrorMessage('Something went wrong, please try again');
                setTimeout(() => {
                    setErrorMessage('');
                }, 4000);
            }
        } catch (error) {
            console.error('Error in editLotHandler:', error);
            setErrorMessage('Something went wrong, please try again');
            setLoading(false);
            setTimeout(() => {
                setErrorMessage('');
            }, 4000);
        }
    }

    const handlePrevClick = () => {
        Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/${Number(lotNumber) - 1}`,
            {state : {auction : auctionData, total_lots : total_lots } })
    }

    const handleNextClick = () => {
        Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/${Number(lotNumber) + 1}`,
            {state : {auction : auctionData, total_lots : total_lots } })
    }

    const getButtonText = () => {
        switch(openExitModal) {
        case 'back': return 'Back to lot list view';
        case 'prev': return 'Go to previous lot';
        case 'next': return 'Go to next lot';
        default: return 'Continue';
        }
    };
    
    const handleNavigation = () => {
        switch(openExitModal) {
        case 'back':
            Navigate(`/auctions/${id}/${uid}/lots${location.state?.search || ''}`);
            break;
        case 'prev':
            handlePrevClick();
            break;
        case 'next':
            handleNextClick();
            break;
        }
    };

    return(<>
        {auctionData && <div className="bg-[#F4F4F5]">
            {/* <!-- Navbar content --> */}
            <Header priceError={priceError}
                setPriceError={setPriceError}
                auctionData={auctionData}
                setLotData={setLotData}
                lotData={lotData} 
                loading={loading}
                isBanner={isBanner} 
                handlePrevClick={handlePrevClick}
                handleNextClick={handleNextClick}
                total_lots={total_lots}
                setIsBanner={setIsBanner}
                edit={edit} lotNumber={lotNumber}
                createLothandler={edit ? editLotHandler : createLothandler}
                originalLotData={originalLotData}
                setOpenExitModal={setOpenExitModal} />
            {/* <!-- main content --> */}
            <div className={`w-full flex ${isBanner ? 'h-[calc(100vh-68px)]' : 'mt-[45px] max-h-[calc(100vh-113px)]'} `}>
                {/* <!-- preview section --> */}
                {auctionData.auction_type=="live" ? 
                    <LiveLotPreview lotData={lotData} auctionData={auctionData} 
                        successToastMessage={successToastMessage}
                        errorMessage={errorMessage} /> : 
                    <PreviewSection lotData={lotData} auctionData={auctionData} 
                        successToastMessage={successToastMessage}
                        errorMessage={errorMessage} />}
                {/* <!-- setup auction desktop view --> */}
                <div id='web-panel-configuration' 
                    className={`xl:w-[26%] lg:w-[30%] md:w-[40%] md:block hidden border-l
                        ${isBanner ? 'h-[calc(100vh-68px)]' : 'max-h-[calc(100vh-113px)]' }
                        border-[#D4D4D8] bg-[#fff] overflow-y-scroll customScrollbar`}>
                    {auctionData.auction_type=="live" ? 
                        <LiveLotSetup lotData={lotData} text={text} setText={setText}
                            auctionData={auctionData}
                            setLotData={setLotData}
                            priceError={priceError}
                            setPriceError={setPriceError} edit={edit}
                            localImages={localImages} setLocalImages={setLocalImages}
                            oldS3Images={oldS3Images} setOldS3Images={setOldS3Images} /> 
                        : 
                        <SetupSection lotData={lotData} text={text} setText={setText}
                            auctionData={auctionData}
                            setLotData={setLotData}
                            priceError={priceError}
                            setPriceError={setPriceError} edit={edit}
                            localImages={localImages} setLocalImages={setLocalImages}
                            oldS3Images={oldS3Images} setOldS3Images={setOldS3Images} />
                    }
                </div>
            </div>
        </div>}
        {loadLots && (
            <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
                <Triangle
                    height="80"
                    width="80"
                    color="#ffff"
                    ariaLabel="triangle-loading"
                    visible={true}
                />
            </div>
        )}
        <ExitModal 
            isOpen={!!openExitModal} 
            setIsOpen={setOpenExitModal} 
            handleSave={edit ? editLotHandler : createLothandler}
            handleNavigation={handleNavigation}
            getButtonText={getButtonText}
            loading={loading} />
    </>
    );
}